import { render } from "./SSOPage.vue?vue&type=template&id=2ed44de8"
import script from "./SSOPage.vue?vue&type=script&lang=js"
export * from "./SSOPage.vue?vue&type=script&lang=js"

import "./SSOPage.vue?vue&type=style&index=0&id=2ed44de8&lang=scss"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__